import React from 'react'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import ProviderOauthButton from 'supporticon/components/provider-oauth-button'
import Heading from 'constructicon/heading'
import RichText from 'constructicon/rich-text'

const JustGiving = ({
  classNames,
  onSuccess,
  styles
}) => (
  <div className={classNames.root}>
    <Heading>Login</Heading>
    <RichText styles={styles.copy}>
      <p>Login by connecting to your existing JustGiving account below.</p>
    </RichText>
    <ProviderOauthButton
      provider='justgiving'
      label='Connect to JustGiving'
      clientId={process.env.JG_OAUTH_API_KEY}
      redirectUri={process.env.JG_REDIRECT_URI}
      onSuccess={data => onSuccess({
        ...data,
        authType: 'Bearer'
      })}
    />
  </div>
)

export default withStyles(styles)(JustGiving)
